class SalutStickyAtc extends HTMLElement {
  connectedCallback() {
    this.input = document.getElementById(this.dataset.quantityInput);
    this.submit = document.getElementById(this.dataset.submitButton);
    if (!this.submit) return;

    this.value = this.querySelector('[data-quantity-value]');
    this.cta = this.querySelector('[data-sticky-submit]');
    this.label = this.querySelector('[data-sticky-label]');
    this.spinner = this.querySelector('.loading__spinner');

    this.querySelectorAll('[data-step]').forEach((button) => {
      button.addEventListener('click', () => this.step(Number(button.dataset.step)));
    });

    this.input?.addEventListener('change', () => this.render());
    this.observeMainButton();
    this.watchSubmitState();
    this.render();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.submitObserver?.disconnect();
    this.resizeObserver?.disconnect();
    document.documentElement.style.removeProperty('--salut-sticky-atc-height');
  }

  observeMainButton() {
    this.observer = new IntersectionObserver(
      ([entry]) => this.toggle(!entry.isIntersecting),
      { rootMargin: '0px 0px -80px 0px' }
    );
    this.observer.observe(this.submit);
  }

  watchSubmitState() {
    this.submitObserver = new MutationObserver(() => this.render());
    this.submitObserver.observe(this.submit, { attributes: true, childList: true, subtree: true });
  }

  toggle(visible) {
    if (visible) {
      this.hidden = false;
      requestAnimationFrame(() => {
        this.classList.add('is-visible');
        this.publishHeight();
      });
      return;
    }
    this.classList.remove('is-visible');
  }

  publishHeight() {
    document.documentElement.style.setProperty('--salut-sticky-atc-height', `${this.offsetHeight}px`);

    if (this.resizeObserver) return;
    this.resizeObserver = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--salut-sticky-atc-height', `${this.offsetHeight}px`);
    });
    this.resizeObserver.observe(this);
  }

  step(delta) {
    if (!this.input) return;

    const min = Number(this.input.min) || 1;
    const max = Number(this.input.max) || Infinity;
    const increment = Number(this.input.step) || 1;
    const next = Number(this.input.value) + delta * increment;

    this.input.value = Math.min(Math.max(next, min), max);
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    this.render();
  }

  render() {
    const quantity = Number(this.input?.value) || 1;
    const min = Number(this.input?.min) || 1;
    const max = Number(this.input?.max) || Infinity;

    this.value.textContent = quantity;
    this.querySelector('[data-step="-1"]').disabled = quantity <= min;
    this.querySelector('[data-step="1"]').disabled = quantity >= max;

    const isLoading = this.submit.classList.contains('loading');
    this.cta.classList.toggle('loading', isLoading);
    this.spinner?.classList.toggle('hidden', !isLoading);
    this.cta.disabled = this.submit.disabled;
    const mainLabel = this.submit.querySelector('span:not(.visually-hidden)')?.textContent.trim();
    if (mainLabel) this.label.textContent = mainLabel;
  }
}

if (!customElements.get('salut-sticky-atc')) customElements.define('salut-sticky-atc', SalutStickyAtc);
